import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import '../styles/page-layout.css';

const ServerErrorPage: React.FC = () => {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <Layout
      title="Server-Fehler | Stimm.DEV"
      description="Es ist ein Server-Fehler aufgetreten. Wir arbeiten daran, das Problem zu beheben."
      keywords="500, Server-Fehler, Technischer Fehler"
    >
      <section className="wrapper">
        <div className="page-container" style={{ textAlign: 'center', padding: '4rem 2rem' }}>
          <div style={{ maxWidth: '600px', margin: '0 auto' }}>
            <h1 style={{ 
              fontSize: '6rem', 
              fontWeight: '800', 
              background: 'linear-gradient(135deg, #e74c3c, #c0392b)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              marginBottom: '1rem'
            }}>
              500
            </h1>
            
            <h2 style={{ 
              fontSize: '2rem', 
              marginBottom: '1rem',
              color: 'var(--text-color)'
            }}>
              Server-Fehler
            </h2>
            
            <p style={{ 
              fontSize: '1.1rem', 
              color: 'var(--text-muted)',
              marginBottom: '2rem',
              lineHeight: '1.6'
            }}>
              Es ist ein technischer Fehler aufgetreten. Unser Team wurde automatisch 
              benachrichtigt und arbeitet bereits an einer Lösung.
            </p>

            <div style={{ 
              display: 'flex', 
              gap: '1rem', 
              justifyContent: 'center',
              flexWrap: 'wrap',
              marginBottom: '3rem'
            }}>
              <button 
                onClick={handleRefresh}
                className="primary-button"
                style={{ 
                  border: 'none',
                  cursor: 'pointer',
                  background: 'var(--primary-color)',
                  color: 'white'
                }}
              >
                <i className="fas fa-sync-alt" style={{ marginRight: '0.5rem' }}></i>
                Seite neu laden
              </button>
              
              <Link 
                to="/" 
                className="secondary-button"
                style={{ textDecoration: 'none' }}
              >
                <i className="fas fa-home" style={{ marginRight: '0.5rem' }}></i>
                Zur Startseite
              </Link>
            </div>

            <div style={{ 
              padding: '2rem',
              background: 'var(--card-background)',
              borderRadius: '1rem',
              border: '1px solid var(--border-color)',
              textAlign: 'left'
            }}>
              <h3 style={{ marginBottom: '1rem', color: 'var(--text-color)' }}>
                Was Sie tun können:
              </h3>
              
              <ul style={{ 
                color: 'var(--text-muted)',
                lineHeight: '1.8',
                paddingLeft: '1.5rem'
              }}>
                <li>Laden Sie die Seite in wenigen Minuten erneut</li>
                <li>Prüfen Sie Ihre Internetverbindung</li>
                <li>Kontaktieren Sie uns, falls das Problem weiterhin besteht</li>
              </ul>

              <div style={{ 
                marginTop: '2rem',
                padding: '1rem',
                background: 'var(--primary-color-light)',
                borderRadius: '0.5rem',
                borderLeft: '4px solid var(--primary-color)'
              }}>
                <strong style={{ color: 'var(--text-color)' }}>
                  Dringend Hilfe benötigt?
                </strong>
                <p style={{ margin: '0.5rem 0 0 0', color: 'var(--text-muted)' }}>
                  Kontaktieren Sie uns direkt unter{' '}
                  <a 
                    href="mailto:support@stimm.dev" 
                    style={{ color: 'var(--primary-color)', textDecoration: 'none' }}
                  >
                    support@stimm.dev
                  </a>
                  {' '}oder{' '}
                  <a 
                    href="tel:+493012345678" 
                    style={{ color: 'var(--primary-color)', textDecoration: 'none' }}
                  >
                    +49 30 123 456 78
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default ServerErrorPage;
